import { Badge } from "@/client/components/ui/badge";
import { PROPAGATION_STATUS_LABEL, type PropagationStatus } from "@/shared/propagation";

/** Propagation state -> badge tone: pending neutral, propagated positive, failed bad. */
const PROPAGATION_VARIANT: Record<PropagationStatus, "default" | "secondary" | "destructive"> = {
  pending: "secondary",
  verified: "default",
  failed: "destructive",
};

/**
 * The single source of truth for how a tenant-initiated config item's
 * propagation state renders. Used wherever the portal surfaces something that
 * automation (or staff in the semi-manual phase) has to roll out - PXE menu,
 * public IPs, and later SSH keys / network ACLs - so the vocabulary and tone
 * stay identical everywhere. See {@link PROPAGATION_STATUS_LABEL}.
 */
export function PropagationBadge({
  status,
  className,
}: {
  status: PropagationStatus;
  className?: string;
}) {
  return (
    <Badge variant={PROPAGATION_VARIANT[status]} className={className}>
      {PROPAGATION_STATUS_LABEL[status]}
    </Badge>
  );
}
